<template>
  <div class="answer-preview-page" :style="pageStyle">
    <!-- 顶部导航栏 -->
    <div class="preview-header">
      <el-button icon="el-icon-back" @click="handleBack">返回</el-button>
      <span class="header-title">答卷详情</span>
      <span class="header-info">
        提交时间：{{ answerInfo.submitTime || '-' }}
      </span>
    </div>
    
    <!-- 主内容区域 -->
    <div class="preview-content">
      <div class="form-main-card" :style="cardStyle">
        <!-- 问卷标题 -->
        <div class="form-header">
          <h1 class="form-title">{{ formTitle }}</h1>
          <div class="form-desc" v-if="formDesc" v-html="formDesc"></div>
        </div>
        
        <!-- 经销商信息（如果有） -->
        <div class="dealer-info" v-if="answerInfo.dealerCode || answerInfo.dealerName">
          <div class="info-item" v-if="answerInfo.dealerCode">
            <span class="label">经销商编码：</span>
            <span class="value">{{ answerInfo.dealerCode }}</span>
          </div>
          <div class="info-item" v-if="answerInfo.dealerName">
            <span class="label">经销商名称：</span>
            <span class="value">{{ answerInfo.dealerName }}</span>
          </div>
        </div>
        
        <!-- 问题列表 -->
        <div class="questions-list">
          <div 
            v-for="(item, index) in formItems" 
            :key="item.itemKey" 
            class="question-item"
          >
            <div class="question-header">
              <span class="question-index">{{ index + 1 }}.</span>
              <span class="question-required" v-if="item.required">*</span>
              <span class="question-label" v-html="item.label"></span>
            </div>
            
            <!-- 答案显示区域 -->
            <div class="answer-display">
              <!-- 选择题 -->
              <template v-if="isChoiceQuestion(item.itemType)">
                <div 
                  v-for="opt in item.options" 
                  :key="opt.value" 
                  class="option-item"
                  :class="{ 'is-selected': isSelected(item.itemKey, opt.value) }"
                >
                  <span class="option-marker">
                    <i v-if="isSelected(item.itemKey, opt.value)" class="el-icon-check"></i>
                    <span v-else class="option-circle"></span>
                  </span>
                  <span class="option-text" v-html="opt.label"></span>
                </div>
              </template>
              
              <!-- 文本题 -->
              <template v-else>
                <div class="text-answer">
                  {{ getAnswerText(item.itemKey) || '未作答' }}
                </div>
              </template>
            </div>
          </div>
        </div>
        
        <!-- 底部信息 -->
        <div class="form-footer">
          <div class="footer-info">
            <span>答题用时：{{ formatDuration(answerInfo.durationSeconds) }}</span>
            <span v-if="answerInfo.totalScore !== undefined">得分：{{ answerInfo.totalScore }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormItems, getAnswerPage } from 'index/api/project/form'

export default {
  name: 'AnswerPreviewPage',
  
  data() {
    return {
      loading: false,
      formTitle: '',
      formDesc: '',
      formItems: [],
      answerMap: {},
      answerInfo: {}
    }
  },
  
  computed: {
    formKey() {
      return this.$route.query.key || ''
    },
    answerKey() {
      return this.$route.query.answerKey || ''
    },
    pageStyle() {
      return {
        background: '#f5f7fa',
        minHeight: '100vh'
      }
    },
    cardStyle() {
      return {
        background: '#fff',
        borderRadius: '8px',
        padding: '30px 40px',
        maxWidth: '800px',
        margin: '0 auto'
      }
    }
  },
  
  created() {
    if (this.formKey && this.answerKey) {
      this.loadData()
    }
  },
  
  methods: {
    handleBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/project')
      }
    },
    
    async loadData() {
      this.loading = true
      try {
        // 加载问卷题目
        const itemsRes = await getFormItems(this.formKey)
        const itemsData = itemsRes?.data?.data || itemsRes?.data || []
        
        this.formItems = itemsData
          .filter(item => !this.isPaginationItem(item.itemType))
          .map(item => ({
            itemKey: item.itemKey || item.item_key,
            itemType: item.itemType || item.item_type,
            label: item.label || item.title,
            required: item.required,
            options: item.options || []
          }))
        
        // 加载答卷数据
        const answerRes = await getAnswerPage({ formKey: this.formKey, page: 1, size: 200 })
        const answerData = answerRes?.data?.data || answerRes?.data || {}
        const records = answerData.records || answerData.list || []
        
        // 找到指定的答卷
        const answer = records.find(r => r.answerKey === this.answerKey)
        if (answer) {
          this.answerInfo = {
            submitTime: answer.submitTime,
            durationSeconds: answer.durationSeconds,
            totalScore: answer.totalScore,
            dealerCode: answer.dealerCode || answer.DealerCode,
            dealerName: answer.dealerName || answer.DealerName
          }
          
          // 构建答案映射
          console.log('[AnswerPreview] answer:', answer)
          if (answer.answers) {
            answer.answers.forEach(ans => {
              this.answerMap[ans.itemKey] = ans.value
            })
            console.log('[AnswerPreview] answerMap:', this.answerMap)
          }
        }
        
        // TODO: 加载问卷标题和描述
        this.formTitle = '问卷详情'
        
      } catch (e) {
        console.error('加载数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    
    isPaginationItem(type) {
      return ['PAGINATION', 'PAGE_BREAK', 'DIVIDER', 'DESCRIPTION'].includes(type)
    },
    
    isChoiceQuestion(type) {
      return ['RADIO', 'CHECKBOX', 'SINGLE_CHOICE', 'MULTIPLE_CHOICE', 'SELECT'].includes(type)
    },
    
    isSelected(itemKey, optionValue) {
      const answer = this.answerMap[itemKey]
      if (!answer && answer !== 0) return false
      
      // 尝试解析为 JSON
      try {
        const selected = JSON.parse(answer)
        if (Array.isArray(selected)) {
          // 多选题
          return selected.some(v => String(v) === String(optionValue))
        }
        // 单选解析出的值
        return String(selected) === String(optionValue)
      } catch {
        // 不是 JSON，直接比较字符串
        return String(answer) === String(optionValue)
      }
    },
    
    getAnswerText(itemKey) {
      return this.answerMap[itemKey] || ''
    },
    
    formatDuration(seconds) {
      if (!seconds) return '00:00:00'
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = seconds % 60
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    }
  }
}
</script>

<style lang="scss" scoped>
.answer-preview-page {
  min-height: 100vh;
}

.preview-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  
  .header-title {
    font-size: 16px;
    font-weight: 600;
    margin-left: 20px;
    color: #303133;
  }
  
  .header-info {
    margin-left: auto;
    color: #909399;
    font-size: 14px;
  }
}

.preview-content {
  padding: 30px 20px;
}

.form-main-card {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  .form-title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
  }
  
  .form-desc {
    color: #909399;
    font-size: 14px;
    line-height: 1.6;
  }
}

.dealer-info {
  background: #f5f7fa;
  padding: 15px 20px;
  border-radius: 6px;
  margin-bottom: 20px;
  
  .info-item {
    display: inline-block;
    margin-right: 30px;
    
    .label {
      color: #909399;
    }
    .value {
      color: #303133;
      font-weight: 500;
    }
  }
}

.questions-list {
  .question-item {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 1px dashed #e4e7ed;
    
    &:last-child {
      border-bottom: none;
    }
  }
  
  .question-header {
    margin-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    
    .question-index {
      font-weight: 600;
      color: #303133;
      margin-right: 2px;
    }
    
    .question-required {
      color: #F56C6C;
      margin-right: 4px;
    }
    
    .question-label {
      color: #303133;
      line-height: 1.6;
      
      ::v-deep p {
        display: inline;
        margin: 0;
      }
    }
  }
}

.answer-display {
  padding-left: 20px;
  
  .option-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    margin-bottom: 8px;
    border-radius: 6px;
    background: #f5f7fa;
    
    &.is-selected {
      background: #ecf5ff;
      border: 1px solid #409EFF;
      
      .option-marker i {
        color: #409EFF;
      }
    }
    
    .option-marker {
      margin-right: 10px;
      
      .option-circle {
        display: inline-block;
        width: 16px;
        height: 16px;
        border: 1px solid #dcdfe6;
        border-radius: 50%;
      }
      
      i {
        font-size: 18px;
        font-weight: bold;
      }
    }
    
    .option-text {
      color: #606266;
    }
  }
  
  .text-answer {
    background: #f5f7fa;
    padding: 15px 20px;
    border-radius: 6px;
    color: #303133;
    line-height: 1.6;
    min-height: 40px;
  }
}

.form-footer {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .footer-info {
    display: flex;
    justify-content: center;
    gap: 30px;
    color: #909399;
    font-size: 14px;
  }
}
</style>
